module.exports = __webpack_public_path__ + "static/media/proPic.2c4fd43a.jpeg";